export default __webpack_public_path__ + "static/media/gustavo-damiano-2.8cb2c3ee.webp";